export default __webpack_public_path__ + "static/media/Monday Loop.c0c530c8.mp3";